import INVENTORY_API_BASE_URL from "../../config/api";
import  { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import Axios from "axios";
import "./CreatePutaway.css";
import swal from "sweetalert";

const CreatePutaway = () => {
  const [data1, setdata1] = useState([]);
  const [present, setpresentquantity] = useState();
  const [New, setNew] = useState();
  const [data, setshelfdata] = useState([]);
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);
  const [setSelectedRack] = useState("");
  const [rackListShown, setRackListShown] = useState(false);
  const [setRackOptions] = useState([]);
  const [selectedSKU, setSelectedSKU] = useState(null);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getCreateGrn`).then((response) => {
     
      setdata1(response.data);
    });
  }, []);  

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then((response) => {
      setshelfdata(response.data);
      const racks = response.data.map((row) => row.rackno);
      setRackOptions(
        racks.filter((rack, index) => racks.indexOf(rack) === index)
      );
    });
  }, []);

  const handleCheckboxChange = (checkbox) => {
    setSelectedCheckbox(checkbox);
    setSelectedRack(""); 
    setSelectedSKU(checkbox.sku); 
    setRackListShown(true);
  };


  const handleQuantityChange = (e, index) => {
    const updatedData = [...filteredData];
    const newQuantity = parseInt(e.target.value);

    updatedData[index].quantity = newQuantity;
    updatedData[index].booksavailable =
      newQuantity + updatedData[index].presentquantity;
    updatedData[index].new = updatedData[index].emptyspace - newQuantity;
    setNew(updatedData[index].new);
    updatedData[index].abc = updatedData[index].booksavailable;
    setshelfdata(updatedData);
    setpresentquantity(updatedData[index].abc);
  };

  const updateShelf = (id) => {
    Axios.put(`${INVENTORY_API_BASE_URL}/putaway`, {
      id: id,
      presentquantity: present,
      emptyspace: New,
    })
      .then(console.log(present))
      .catch((err) => console.log(err));

    swal({
      title: "Putaway Created",
      text: "",
      icon: "success",  
    });
    window.location.reload();
  };

  const filteredData = data.filter((item) => item.sku === selectedSKU);

  return (
    <div style={{ marginLeft: "22rem", marginTop: "5rem" }}>
      <h3>Create Putaway</h3>
      <div className="putawaycontainer">
        <div className="putawaycontent">
          <Table responsive className="putawaytable">
            <thead>
              <tr>
                <th>Order Id</th>
                <th>SKU</th>
                <th>Approved Quantity</th>
                <th>Quantity Received</th>
                <th>Create Putaway</th>
              </tr>
            </thead>
            <tbody>
              {data1.map((checkbox) => (
                <tr key={checkbox.id}>
                  <td>{checkbox.orderno}</td>
                  <td>{checkbox.sku}</td>
                  <td>{checkbox.quantity}</td>
                  <td>{checkbox.quantityreceived}</td>
                  <td>
                    <button
                      type="button"
                      className="putawaybtn"
                      onClick={() => handleCheckboxChange(checkbox)}
                    >
                      Create
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      {selectedCheckbox && rackListShown && (
        <div>
          <h4>Selected SKU: {selectedSKU}</h4>

          {filteredData.length > 0 ? (
            <>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Rack</th>
                    <th>Shelf</th>
                    <th>Type</th>
                    <th>Capacity</th>
                    <th>Add Quantity</th>
                    <th>Empty Space</th>
                    <th>Current Present Quantity</th>
                    <th>Present Quantity(books)</th>
                    <th>Create Putaway</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.rackno}</td>
                        <td>{item.shelfno}</td>
                        <td>{item.type}</td>
                        <td>{item.capacity}</td>
                        <td>
                          <input
                            type="number"
                            value={item.quantity}
                            onChange={(e) => handleQuantityChange(e, index)}
                          />
                        </td>

                        <td>{item.new}</td>
                        <td>{item.presentquantity}</td>
                        <td>{item.booksavailable}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              updateShelf(item._id);
                            }}
                          >
                            Update
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </>
          ) : (
            <p>No shelves found for the selected SKU.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default CreatePutaway;

